<script>

import FetchCall from '../../../shared/local_fetch_call'
import Hotel from '../../../classes/hotel'
import { mapMutations, mapGetters } from 'vuex'
import moment from 'moment'

export default {
  methods: {
    ...mapMutations('hotel', [
      'clearNonContractedHotels',
      'setRetailLoading',
      'updateHotelsArray',
      'settotalRetailHotels',
      'setLoading'
    ]),
    ...mapGetters('hotel', ['getContractedHotels']),
    removeDuplicates(retailHotels){
      let contractedIds = []
      this.getContractedHotels().forEach(hotel => {
        contractedIds.push(hotel.id)
      })

      let displayableHotels = []
      retailHotels.map(hotel =>{
        if(!contractedIds.includes(hotel['@HotelID'])){
          displayableHotels.push(hotel)
        }
      })

      return displayableHotels
    },
    async fetchAvailableHotels(latitude, longitude, checkIn, checkOut, roomQty) {
      let res = await FetchCall.fetchWithoutLocale(
        '/api/h4h_hotels' +
        `?latitude=${latitude}` +
        `&longitude=${longitude}` +
        '&radius=25' +
        `&inDate=${checkIn}` +
        `&outDate=${checkOut}` +
        `&rooms=${roomQty}`,
        'GET',
        null
      )

      this.setRetailLoading(false)

      if (res.ArnResponse.Availability) {
        this.hotels = this.removeDuplicates(res.ArnResponse.Availability.HotelAvailability.Hotel)
      }

      this.createHotelObject(false)
    },
    async createHotelObject(isContracted) {
      this.clearNonContractedHotels()

      let hotelsArray = []

      if(this.hotels) {
        for (let i = 0; i < this.hotels.length; i++) {
          const hotel = new Hotel(this.hotels[i], isContracted)
          if (!hotel.id || hotel.rooms.length === 0) continue

          let checkIn = isContracted ?
            moment(this.hotels[i].check_in_date) :
            moment(this.$store.state.hotel.checkInDate)
          let checkOut = isContracted ?
            moment(this.hotels[i].check_out_date) :
            moment(this.$store.state.hotel.checkOutDate)

          if (isContracted) {
            await hotel.updateHotelInfo(this.$store.state.hotel.eventLatitude, this.$store.state.hotel.eventLongitude)
          } else {
            hotel.updateHotelInfo(this.$store.state.hotel.eventLatitude, this.$store.state.hotel.eventLongitude)
          }

          hotel.checkIn = checkIn._d
          hotel.checkOut = checkOut._d

          let yesterday = moment().subtract(1, 'days')._d
          if ((checkIn >= yesterday ) && (checkOut >= yesterday)) {
            hotel.stayDuration = moment(checkOut).diff(checkIn, 'days')
          } else {
            hotel.tbdDates = true
          }

          if ((checkIn < yesterday) && (checkOut < yesterday) && !hotel.stayDuration) continue
          hotelsArray.push(hotel)
        }
      }
      this.settotalRetailHotels(hotelsArray)
      this.updateHotelsArray(hotelsArray)
      if (!this.orderItem || !this.orderItem.h4h_hotel_attributes.hotel_id) {
        this.setLoading(false)
      }
    }
  }
}
</script>
